<template>
    <div>
        <b-row>
            <b-col cols="0" sm="3"	md="4"	lg="4"	xl="4"></b-col>
            <b-col cols="12" sm="6"	md="4"	lg="4"	xl="4">
                <div class="col-md-12 text-center">
                    <b-button variant="secondary" @click="listOrdenCompra"><i class="fa fa-sync-alt"></i> </b-button>
                </div>
            </b-col>
            <b-col cols="12" sm="6"	md="4"	lg="4"	xl="2"></b-col>
            <b-col md="2">
                <b-form-group horizontal label="Mostrar">
                <b-input-group>
                    <b-form-select v-model="limite" slot="append" @input="listOrdenCompra">
                        <option :value="10">10</option>
                        <option :value="25">25</option>
                        <option :value="50">50</option>
                        <option :value="100">100</option>
                    </b-form-select>
                </b-input-group>
            </b-form-group>
            </b-col>
        </b-row><br>
        <b-row>
            <b-col cols="12" sm="12"	md="12"	lg="12"	xl="12">
                <b-table 
                    responsive
                    small
                    striped
                    outlined
                    :items="ordenescompra"
                    :fields="ordenescompra_fields"
                    :current-page="pactual"
                    :per-page="limite"
                    :sort-by.sync="sortBy"
                    :sort-desc.sync="sortDesc"
                    :sort-direction="sortDirection"
                    :busy="procesandooredenes"
                    @filtered="onFiltered"
                    >
                    <div slot="table-busy" class="text-center text-danger my-2">
                        <b-spinner class="align-middle"></b-spinner>
                        <strong> Cargando...</strong>
                    </div>
                    <template slot="emision" slot-scope="row">
                        {{ row.item.created_at | moment('D/M/Y hh:mm:ss A') }}
                    </template>
                    <template slot="receptor" slot-scope="row">
                        <template>
                            {{row.item.ordenCompra.receptor.nro}} - {{row.item.ordenCompra.receptor.razonSocial}}
                        </template>
                    </template>
                    <template slot="montoTotal" slot-scope="row">
                        <template v-if="row.item.ordenCompra.totales.importeTotal">
                            {{row.item.ordenCompra.moneda.simbolo}} {{row.item.ordenCompra.totales.importeTotal.toFixed(2)}}
                        </template>
                        <template v-else>{{row.item.ordenCompra.moneda.simbolo}} 0.00</template>
                    </template>
                    <template slot="acciones" slot-scope="row">
                        <b-button-group>
                            <button size="sm" @click="row.toggleDetails" type="button" class="btn" title="Mas opciones">
                                <template v-if="!row.item.mostrardetalles">
                                    <i class="fa fa-plus"></i>
                                </template>
                                <template v-else>
                                    <i class="fa fa-minus"></i>
                                </template>
                            </button>
                            <b-button size="sm" v-b-tooltip.hover variant="primary" @click="returnOrdenCompra(row.index, row.item)"><i class="fa fa-pencil-alt" title="Editar Proforma"></i></b-button>
                            <b-button size="sm" v-b-tooltip.hover variant="secondary" @click="sendOC(row)"><i class="fa fa-tv" title="Ver Orden Compra"></i></b-button>
                            <b-button size="sm" v-b-tooltip.hover v-b-modal.sendproformaemail variant="secondary" @click="dataSendMail(row.item)"><i class="fa fa-envelope" title="Enviar por Correo (Proximanente)"></i></b-button>
                            <b-button size="sm" v-b-modal.sendfacturaemail1 v-b-tooltip.hover variant="danger" @click="predeleteOrdenCompra(row.item)"><i class="fa fa-trash" title="Eliminar Proforma"></i></b-button>
                        </b-button-group>
                    </template>
                    <template v-slot:row-details="row">
                        <b-card>
                            <b-table
                             head-variant="light"
                            :outlined="outlined"
                            striped
                            hover
                            :items="row.item.ordenCompra.items"
                            :fields="listaitems_fields"
                            :busy="row.item.loading"
                            >
                            <div slot="table-busy" class="text-center text-danger my-2">
                                <b-spinner class="align-middle"></b-spinner>
                                <strong>Cargando...</strong>
                            </div>
                            <template slot="index" slot-scope="row">{{ row.index+1 }}</template>
                            <template slot="cantidad" slot-scope="row">
                                <div>{{ Number.parseFloat(row.item.cantidad).toFixed(2) }}</div>
                            </template>
                            <template slot="precioVentaUnitario" slot-scope="row">
                                <template v-if="row.item.moneda=='PEN'">S/</template>
                                <template v-else-if="row.item.moneda=='USD'">$</template>
                                <template v-else>{{ row.item.moneda }}</template>
                                <template
                                    v-if="row.item.precioVentaUnitario"
                                >{{ Number.parseFloat(row.item.precioVentaUnitario).toFixed(2) }}</template>
                            </template>
                            <template slot="descuento" slot-scope="row">
                                <template v-if="row.item.moneda=='PEN'">S/</template>
                                <template v-else-if="row.item.moneda=='USD'">$</template>
                                <template v-else>{{ row.item.moneda }}</template>
                                {{ Number.parseFloat(row.item.descuento).toFixed(2) }}
                            </template>
                            <template slot="valorVenta" slot-scope="row">
                                <template v-if="row.item.moneda=='PEN'">S/</template>
                                <template v-else-if="row.item.moneda=='USD'">$</template>
                                <template v-else>{{ row.item.moneda }}</template>
                                <template v-if="row.item.valorVenta">
                                    {{ Number.parseFloat(row.item.valorVenta*(row.item.porcentajeImpuesto == '18.00000' ? 1.18 : 1.105)).toFixed(2) }}
                                    <div style="float:right;color:red">
                                        {{row.item.porcentajeImpuesto == '18.00000' ? '18%' : '10.5%'}}
                                    </div>
                                </template>
                            </template>
                            </b-table>
                            <label v-if="row.item.ordenCompra.observaciones != null" style="color:red">observaciones: </label> {{row.item.ordenCompra.observaciones}} 
                            <!-- <label v-if="row.item.ordenCompra.atencion != null" style="color:red">Atencion: </label> {{row.item.ordenCompra.atencion}}  -->
                            <label v-if="row.item.ordenCompra.plazoentrega != null" style="color:red">Plazo Entrega: </label> {{row.item.ordenCompra.plazoentrega}} 
                            <label v-if="row.item.ordenCompra.formapago != null" style="color:red">Forma de Pago: </label> {{row.item.ordenCompra.formapago.nombre}} 
                            <label v-if="row.item.ordenCompra.garantia != null" style="color:red">Garantia: </label> {{row.item.ordenCompra.garantia}} 
                            <label v-if="row.item.ordenCompra.telefono != null" style="color:red">Telefono: </label> {{row.item.ordenCompra.telefono}} 
                        </b-card>
                    </template>
                </b-table>
                <b-row>
                    <b-col cols="12"	sm="4"	md="6"	lg="8"	xl="8">
                        <p>Mostrando del {{desde}} al {{hasta}} de un total de {{total}} registros</p>
                    </b-col>
                    <b-col cols="12"	sm="8"	md="6"	lg="4"	xl="4">
                        <b-pagination size="sm" :total-rows="total" v-model="currentPage" :per-page="limite" @input="listOrdenCompra"></b-pagination>
                    </b-col>
                </b-row>
            </b-col>
        </b-row>
        <b-modal id="messageConvert" size="lg" title="Informativo Telemovil" cancel-title="Cerrar" v-model="noticeConvert">
        <b-row>
            <b-col cols="7">
                <img src="images/informativo.png" alt="Logo">
            </b-col>
            <b-col cols="5">
                <br><br><br><br><br>
                <p class="notice">{{ bodycomment }}</p>
                <br>
                <h5 v-if="tipoDocConvert===3">Nota: A excepcion de los items por servicios</h5>
            </b-col>
        </b-row>
        <div slot="modal-footer">
            <b-btn size="md" variant="primary" @click="convertInvoice()">
                Continuar
            </b-btn>
        </div>
    </b-modal>
    <b-modal id="pdfordencompra" size="lg" title="Vista Previa" cancel-title="Cerrar" v-model="pdfordencompra">
        <template v-if="cargandopdfoc"><div class="text-center"><h3><i class="fa fa-spin fa-spinner"></i></h3> Cargando vista previa</div></template>
        <template v-else>
        <template v-if="pdfobject !==''">
            <b-embed :src="'data:application/pdf;base64,'+ pdfobject" allowfullscreen></b-embed>
        </template>
        </template>
    </b-modal>
    <b-modal id="sendproformaemail" title="Enviar por Correo" v-model="previacorreo">
        <div role="group">
        <label for="inputLive">Correos:</label>
        <b-form-input v-model="recipients" type="email" @keyup.enter="sendMail()"></b-form-input>
        <p class="input-requerido">Ingresa un correo ó varios separados por comas (,)</p>
        </div>
            <div slot="modal-footer" class="w-100">
            <b-btn v-if="!sendcorreo" size="sm" class="float-right" variant="primary" @click="sendMail()">
            Enviar
            </b-btn>
            <b-btn v-else size="sm" class="float-right" variant="secondary">
            <i class="fa fa-spin fa-spinner"></i> Enviando...
            </b-btn>
        </div>
    </b-modal>
    <vue-snotify></vue-snotify>
    </div>
</template>

<script>
import axios from 'axios'
import ModalPreview from '@/components/factura/complementos/ModalPreview'
    export default {
       name: 'OrdenCompraConsulta',
       components: {
           ModalPreview
       },
       data: () => {
           return {
                bodycomment: 'Esta a punto de convertir esta proforma en Factura',
                noticeConvert: false,
                total: 0.00,
                desde: 0.00,
                hasta: 0.00,
                totalRows: 0,
                pdfobject: null,
                cargando: false,
                small: true,
                striped: true,
                outlined: true,
                pactual: 1,
                limite: 10,
                sortBy: null,
                sortDesc: false,
                sortDirection: 'desc',
                ordenescompra: [],
                ordenescompra_fields: [
                    {key: 'serie', label: 'Serie', sorteable: true},
                    {key: 'numero', label: 'Numero', sorteable: true},
                    {key: 'emision', label: 'Emisión', sorteable: true},
                    {key: 'receptor', label: 'Receptor', sorteable: true},
                    {key: 'montoTotal', label: 'Monto Total', sorteable: true},
                    {key: 'acciones', label: 'Acciones'},
                ],
                listaitems_fields: [
                    { key: "index" },
                    { key: "codigoProducto", label: "Codigo", sorteable: true },
                    { key: "unidadMedidaCantidad", label: "Unidad", sorteable: true },
                    { key: "descripcion", label: "Descripción", sorteable: true },
                    { key: "cantidad", label: "Cantidad", sorteable: true },
                    { key: "precioVentaUnitario", label: "Precio Unit", sorteable: true },
                    { key: "descuento", label: "Descuento", sorteable: true },
                    { key: "valorVenta", label: "Precio Total", sorteable: true }
                ],
                ordencompra: {},
                procesandooredenes: false,
                bufferData: {},
                tipoDocConvert: 1,
                pdfordencompra: false,
                cargandopdfoc: false,
                previacorreo: false,
                recipients: '',
                sendcorreo: false,
                currentPage: 1,
           }
       },
       created() {
            this.listOrdenCompra()
       },
       mounted() {
           this.initReturn()
       },
       methods: {
           onFiltered (filteredItems) {
                this.totalRows = filteredItems.length
                this.currentPage = 1
           },
           dataSendMail: function (data) {
               this.ordencompra = data
           },
           sendMail: function () {
               this.previacorreo = true,
                this.sendcorreo = true,
                axios
                .post(process.env.VUE_APP_API_URL + 'ordencompra/pdf/mail', {
                    token: this.$store.getters.userToken,
                    id: this.ordencompra.idOrdenCompra,
                    mail: this.recipients
                })
                .then(response => (
                    this.sendcorreo = false,
                    this.previacorreo = false,
                    this.$snotify.success(response.data.msg, 'Exito')
                ))
                .catch(error => (
                    this.previacorreo = false,
                    this.$snotify.error(error.response.data.response, 'Error')
                ))
           },
           sendOC: function (row) {
               this.pdfordencompra = true,
                this.pdfobject = '',
                this.cargandopdfoc = true
                axios
                .post(process.env.VUE_APP_API_URL + 'ordencompra/pdf', {
                    token: this.$store.getters.userToken,
                    id: row.item.idOrdenCompra
                })
                .then(response => (
                    this.pdfobject = response.data.pdf,
                    this.cargandopdfoc = false
                ))
                .catch(error => {
                    this.cargandopdfoc = false,
                    this.pdfproforma = false,
                    this.$snotify.error(error.response.data.msg,'Error')
                })
           },
           listOrdenCompra: function () {
                this.procesandooredenes = true
                axios
                .post(process.env.VUE_APP_API_URL + 'ordencompra/listar', {
                    token: this.$store.getters.userToken,
                    page: this.currentPage,
                    limit: this.limite,
                    order: this.orden
                })
                .then(response => (
                    this.procesandooredenes = false,
                    this.ordenescompra = response.data.data,
                    this.total = response.data.total,
                    this.desde = response.data.from,
                    this.hasta = response.data.to
                ))
                .catch(error => {
                    this.$snotify.error(error.response.data.msg,'Error'),
                    this.procesandooredenes = false
                })
            },
            returnOrdenCompra: function (index, item) {
                this.changeTab(2),
                this.editOrdenCompra(item)
            },
            initReturn: function () {
                let proformaBlank = {}
                this.editOrdenCompra(proformaBlank)
            },
            predeleteOrdenCompra: function (value) {
                this.$swal({
                title: 'Eliminar Orden de Compra',
                text: 'Seguro de eliminar la Orden de Compra '+ value.serie +' - '+ value.numero,
                icon: 'error',
                buttons: true,
                dangerMode: true
                }).then((willDelete) => {
                    if(willDelete){
                        this.deleteOrdenCompra(value.idOrdenCompra)        
                    }
                })
            },
            deleteOrdenCompra: function (value) {
                this.procesandooredenes = true
                axios
                .post(process.env.VUE_APP_API_URL + 'ordencompra/eliminar', {
                    token: this.$store.getters.userToken,
                    id: value
                })
                .then(response => (
                    this.$snotify.success(response.data.msg,'Exito'),
                    this.listOrdenCompra()
                ))
                .catch(error => {
                    this.$snotify.error(error.response.data.msg,'Error')
                })
            },
            editOrdenCompra: function (value){
                this.$emit("ordencompra", value);
            },
            changeTab: function (value){
                this.$emit("tabindex", value);
            }
       }
    }
</script>

<style>
    .notice{
        font-size: 2em;
        color: #006666;
    }
    .tamanioletra {
        font-size: 13px;
        font-family: "Roboto Mono";
        margin-left: 3%;
        padding: 0px;
    }
</style>

<style>
@import url("https://fonts.googleapis.com/css?family=Roboto+Mono&display=swap");
</style>